import React from 'react'
import ReactImages from 'react-images'

export class Lightbox extends React.PureComponent {
  state = {
    isOpen: false,
    photos: [],
    currentImage: 0,
  }

  componentWillMount () {
    this.setPhotos(this.props.photos)
  }

  componentWillReceiveProps (nextProps) {
    this.setPhotos(nextProps.photos)
  }

  setPhotos (photos) {
    this.setState({
      ...this.state,
      photos: photos.map((photo) => ({ src: photo.url, srcset: [photo.url] })),
    })
  }

  open (index) {
    this.setState({
      ...this.state,
      isOpen: true,
      currentImage: index,
    })
  }

  onClose () {
    this.setState({
      ...this.state,
      isOpen: false,
    })
  }

  onClickNext () {
    this.setState({
      ...this.state,
      currentImage: Math.min(this.state.photos.length - 1, this.state.currentImage + 1),
    })
  }

  onClickPrev () {
    this.setState({
      ...this.state,
      currentImage: Math.max(0, this.state.currentImage - 1),
    })
  }

  render () {
    const { isOpen, photos, currentImage } = this.state

    return (
      <ReactImages
        isOpen={isOpen}
        onClose={() => this.onClose()}
        onClickNext={() => this.onClickNext()}
        onClickPrev={() => this.onClickPrev()}
        images={photos}
        currentImage={currentImage}
      />
    )
  }
}

export default Lightbox



// WEBPACK FOOTER //
// ./app/javascript/components/ItemPhotos/Lightbox.js